"use client";

import React from "react";
import Link from "next/link";
import { motion } from "framer-motion";
import { FaArrowRight, FaStar, FaAward } from "react-icons/fa";

const PremiumHeroSection = () => {
  return (
    <section className="relative w-full min-h-[700px] flex items-center justify-center overflow-hidden bg-slate-900 pt-24">
      
      {/* --- Background Image with Parallax-like feel --- */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat bg-fixed opacity-20 transform scale-105"
        style={{ backgroundImage: "url('/images/course-bg-pattern.jpg')" }} // Ensure you have a subtle tech/abstract pattern here, or keep your bg-bg-course class
      ></div>

      {/* --- Gradient Overlays --- */}
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-slate-900 via-slate-900/80 to-slate-900/40"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-blue-600/20 rounded-full blur-[120px] z-10 pointer-events-none"></div>

      {/* --- Main Content --- */}
      <div className="container relative z-20 px-4 md:px-6 py-20 mx-auto text-center">
        
        {/* Floating Badge */}
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 px-4 py-2 mb-8 rounded-full bg-white/5 border border-white/10 backdrop-blur-md shadow-xl"
        >
          <span className="flex items-center justify-center w-6 h-6 rounded-full bg-yellow-500 text-slate-900 text-xs">
            <FaStar />
          </span>
          <span className="text-sm font-medium text-yellow tracking-wide uppercase">
            Top Rated Learning Platform
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="max-w-4xl mx-auto text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight text-white leading-tight"
        >
          Master <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">Premium Skills</span> <br className="hidden md:block" />
          To <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow to-orange-400">Enhance</span> Your Future
        </motion.h1>

        {/* Subtitle */}
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="max-w-2xl mx-auto mt-6 text-lg md:text-xl text-slate-300 leading-relaxed"
        >
          Vidyastu provides industry-standard training for job-oriented courses in Kolkata. 
          Bridge the gap between education and employment.
        </motion.p>

        {/* Stats / Trust Markers (Optional decoration) */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.8 }}
          className="mt-16 pt-8 border-t border-white/5 flex flex-wrap justify-center gap-8 md:gap-16"
        >
          <div className="flex items-center gap-3 text-slate-400">
            <FaAward className="text-2xl text-blue-500" />
            <div className="text-left">
              <p className="text-white font-bold text-lg leading-none">100%</p>
              <p className="text-xs text-yellow uppercase tracking-wider">Job Assistance</p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-slate-400">
            <div className="w-10 h-10 rounded-full border-2 border-slate-700 flex items-center justify-center bg-slate-800">
              <span className="font-bold text-white">A+</span>
            </div>
            <div className="text-left">
              <p className="text-white font-bold text-lg leading-none">Certified</p>
              <p className="text-xs text-yellow uppercase tracking-wider">Curriculum</p>
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default PremiumHeroSection;